__turbopack_context__.v({
  "rating": "app-store-rating-module-scss-module__mImEuG__rating",
  "reviews": "app-store-rating-module-scss-module__mImEuG__reviews",
  "section": "app-store-rating-module-scss-module__mImEuG__section",
});
